import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Radio from 'react-bootstrap/lib/Radio';

// This must be a stateful component because we want to be able to attach a `ref` to it so it can be focused
export default class RadioWrapper extends React.PureComponent {

    static propTypes = {
        checked: PropTypes.bool,
        label: PropTypes.any,
        labelClassName: PropTypes.string,
        srOnly: PropTypes.string,
        hasIcon: PropTypes.any,
        hasBorder: PropTypes.bool,
        hasFocus: PropTypes.bool,
        radioClass: PropTypes.string,
        isFirstClass: PropTypes.bool,
        isDisabled: PropTypes.bool,
    };

    render () {
        const {
            label,
            labelClassName,
            srOnly,
            hasIcon,
            hasBorder,
            hasFocus,
            radioClass,
            isFirstClass,
            isDisabled,
            ...props
        } = this.props;

        if (srOnly) {
            return (
                <Radio { ...props }>
                    <span aria-hidden="true" className={ labelClassName }>{ label }</span>
                    <span className="sr-only">{ srOnly }</span>
                </Radio>
            );
        }

        const spanClasses = cn({
            'radio-with-icon': hasIcon,
            'radio-with-border': hasBorder,
        });

        return (
            <Radio autoFocus={ this.props.checked && hasFocus } { ...props } className={ radioClass }>
                <span className={ spanClasses }>
                    { hasIcon }
                    { label }
                    { isFirstClass && <span className='radio-first-class'>First Class</span> }
                    { isDisabled && <span className='disabled-radio-message'>Unavailable in this type of ticket.</span> }
                </span>
            </Radio>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/form/Radio.js